import { renderSections } from "./sectionRegistry";

/**
 * Supplier landing template — used by 6 of the 7 page types.
 *
 * Pure loop: it renders whatever is in `config.sections`, in order. There are no
 * hardcoded sections — hero, FAQ and CTA are section types too, so any of them
 * can be omitted, repeated, or reordered purely from the config. Adding a new
 * section type = register it in `sectionRegistry.js`, no template change.
 */
export default function SupplierLandingTemplate({ config }) {
  return <main>{renderSections(config.sections)}</main>;
}
